/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import shortid from 'shortid';

import isFunction from 'utils/isFunction';

import TableCell from '../TableCell';

import './TableRow.scss';

const TableRow = ({ className = '', cells = [], append, children = null, colSpan }) => {
  const rowid = useMemo(() => shortid.generate(), []);
  const classes = classnames('TableRow', className);

  return (
    <tr className={classes}>
      {cells &&
        !children &&
        cells.map((cell, i) => (
          <TableCell
            colSpan={isFunction(colSpan) ? colSpan(i) : colSpan}
            className={`${cell === 0 ? 'TableCell--zero' : ''}`}
            key={`${rowid} ${i}`}
          >
            {cell}
          </TableCell>
        ))}
      {children}
      {append}
    </tr>
  );
};

export default TableRow;
